import React from "react";
import "./ShortcutDropdown.css";

export default function ShortcutDropdown({
  shortcuts,
  selectedIndex,
  onSelect,
}) {
  if (!shortcuts || shortcuts.length === 0) return null;

  return (
    <div className="shortcut-dropdown-container">
      {shortcuts.map((s, index) => (
        <button
          key={s.id}
          type="button"
          className={
            "shortcut-dropdown-item" +
            (index === selectedIndex ? " shortcut-dropdown-item-active" : "")
          }
          onMouseDown={(e) => {
            e.preventDefault(); 
            onSelect(s);
          }}
        >
          {/* COMMAND */}
          <span className="shortcut-dropdown-command">/{s.command}</span>

          {/* TÍTULO */}
          <span className="shortcut-dropdown-title">
            {s.title || "Sem título"}
          </span>

          {/* MENSAGEM */}
          <p className="shortcut-dropdown-message">
            {s.message?.length > 70
              ? s.message.slice(0, 70) + "..."
              : s.message}
          </p>
        </button>
      ))}

      {/* =================================== */}
      {/*   RODAPÉ PREMIUM COM CHIPS BONITOS  */}
      {/* =================================== */}
      <div className="shortcut-dropdown-footer">
        <span className="shortcut-footer-chip">↑</span>
        <span className="shortcut-footer-chip">↓</span>
        para navegar &nbsp; • &nbsp;
        <span className="shortcut-footer-chip">Enter</span>
        para escolher &nbsp; • &nbsp;
        <span className="shortcut-footer-chip">Esc</span>
        para fechar
      </div>
    </div>
  );
}


